/**
 * CONTEXT AND REDUCER
 *  GLOBALE SCOPE: 
 *  1. STORE OBJECT LIST 
 *  2. PERFORM UPDATE ON OBJECT DATA
 */

import {createContext,useContext,useReducer} from "react";

export const AppDataContext         = createContext(null);
export const AppDataContextDispatch =  createContext(null);

export function AppDataProvider({children}) {

    const initAppData =  {};

    const [AppData, dispatch] =  useReducer(AppDataReducer,initAppData)

    return(
        <AppDataContext value={AppData}>
            <AppDataContextDispatch value={dispatch}>
                {children}
            </AppDataContextDispatch>
        </AppDataContext>
    )
}

// reference functions
export function useAppData()         {return(useContext(AppDataContext))};
export function useAppDataDispatch() {return(useContext(AppDataContextDispatch))};


export function AppDataReducer(AppData, oAction) {

    switch(oAction.type) {
        case 'upd_route':
        AppData.location = oAction.location;
        // return(AppData);
        break;

        default: //

    }

    return(AppData);

}
 